__turbopack_context__.v({
  "className": "figtree_be54c76e-module__tihxwq__className",
  "variable": "figtree_be54c76e-module__tihxwq__variable",
});
